export default "__VITE_PUBLIC_ASSET__bb632089__"